<template>
    <div :class="['alert font-size-10 text-left', typeClass]" role="alert">
        <span v-html="message" />
        <button type="button" class="close" aria-label="Close" @click="$emit('close')" v-if="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'error',
        },
        message: {
            type: String,
            default: '',
        },
        close: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        typeClass() {
            switch (this.type) {
                case 'success':
                return 'alert-success';
                case 'warning':
                return 'alert-warning';
                case 'info':
                return 'alert-info';
                default:
                return 'alert-danger';
            }
        },
    },
};
</script>

<style scoped>
    .close {
        float: none;
        position: absolute;
        right: 10px;
        top: 10px;
    }
</style>
